module.exports = __webpack_public_path__ + "img/renew02.b5778d89.jpeg";